(function () {
  var CARD_SELECTOR = "product-card, .product-card, .card-wrapper, .product-card-wrapper";

  function blockForm(form) {
    if (!form || form.dataset.comingSoonBlocked === "true") return;
    form.dataset.comingSoonBlocked = "true";
    form.addEventListener(
      "submit",
      function (event) {
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );
    var controls = form.querySelectorAll('button[name="add"], button[type="submit"], [type="submit"]');
    for (var i = 0; i < controls.length; i += 1) {
      if (controls[i].closest("[data-coming-soon-root]")) continue;
      controls[i].setAttribute("disabled", "disabled");
      controls[i].setAttribute("aria-disabled", "true");
    }
  }

  function hidePaymentButtons(scope) {
    if (!scope) return;
    var buttons = scope.querySelectorAll(".shopify-payment-button");
    for (var i = 0; i < buttons.length; i += 1) {
      buttons[i].hidden = true;
    }
  }

  function guardCard(badge) {
    var card = badge.closest(CARD_SELECTOR);
    if (!card) return;
    var forms = card.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i += 1) blockForm(forms[i]);
    var quickAdd = card.querySelectorAll(".product-card__quick-add-button, .quick-buy-modal");
    for (var q = 0; q < quickAdd.length; q += 1) {
      quickAdd[q].hidden = true;
    }
    hidePaymentButtons(card);
  }

  function guardProduct(root) {
    var form = root.closest('form[action*="/cart/add"]');
    blockForm(form);
    hidePaymentButtons(root.closest("buy-buttons") || root.parentElement);
  }

  function init() {
    var badges = document.querySelectorAll(".coming-soon-badge");
    for (var i = 0; i < badges.length; i += 1) guardCard(badges[i]);
    var roots = document.querySelectorAll("[data-coming-soon-root]");
    for (var j = 0; j < roots.length; j += 1) guardProduct(roots[j]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();